import { z } from 'zod';

const PaddockTypeDef = [
    'Grazing',
    'Planting',
    'Fallow/Unused',
    'Regenerative/Regrowth (enviro)',
    'No Till',
] as const;

export const allPaddockTypes = [...PaddockTypeDef];

export type PaddockType = (typeof PaddockTypeDef)[number];

export const paddockTypeSchema = z.enum(PaddockTypeDef);
